<script>
import { Line, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  extends: Line,
  mixins: [reactiveProp],
  props: {
    datasets: {
      type: Array
    },
    options: {
      type: Object,
      default: null
    },
  },
  mounted () {
    this.renderChart(this.chartData, this.options)
  },
  watch: {
    chartData () {
      this.$data._chart.update()
    },
    options() {
      this.$data._chart.destroy()
      this.renderChart(this.chartData, this.options)
    }
  }
}
</script>
